export const textTypeEnum = Object.freeze({
  uniqueValue: 'uniqueValue',
  predictValue: 'predictValue',
  empty: "empty",
  notEmpty: "notEmpty",
  textContains: "textContains",
  textDoesNotContain: "textDoesNotContain",
  textStartsWith: "textStartsWith",
  textEndsWith: "textEndsWith",
  textIsExactly: "textIsExactly",
});

export const numberTypeEnum = Object.freeze({
    uniqueValue: 'uniqueValue',
    predictValue: 'predictValue',
    empty: "empty",
    notEmpty: "notEmpty",
    moreThan: "moreThan",
    moreThanOrEqualTo: "moreThanOrEqualTo",
    lessThan: "lessThan",
    lessThanOrEqualTo: "lessThanOrEqualTo",
    equal: "equal",
    notEqual: "notEqual",
    isBetween: "isBetween",
    isNotBetween: "isNotBetween",
  });

export const dateTypeEnum = Object.freeze({
    uniqueValue: 'uniqueValue',
    predictValue: 'predictValue',
    empty: "empty",
    notEmpty: "notEmpty",
    dateIs: "dateIs",
    dateIsBefore: "dateIsBefore",
    dateIsAfter: "dateIsAfter",
    isBetween: "isBetween",
    isNotBetween: "isNotBetween",
  });

export const colorSchemeType = Object.freeze({
  conditionalColor: "conditional_color",
  gradient: "gradient",
});

export const columnDataType = Object.freeze({
    text: "text",
    date: "date",
    number: "number",
    checkbox: "checkbox",
    link: "link",
    default: 'default',
});

export const conditionTabId = Object.freeze({
  basic: "basic",
  advance: "advance",
});

export const keyIndexesForData = {
  firstValue: 0,
  secondValue: 1,
}


export const conditionsType = Object.freeze({
  uniqueValue: 'uniqueValue',
  empty: "empty",
  predictValue: 'predictValue',
  notEmpty: "notEmpty",
  moreThan: "moreThan",
  moreThanOrEqualTo: "moreThanOrEqualTo",
  lessThan: "lessThan",
  lessThanOrEqualTo: "lessThanOrEqualTo",
  equal: "equal",
  notEqual: "notEqual",
  isBetween: "isBetween",
  isNotBetween: "isNotBetween",
  dateIs: "dateIs",
  dateIsBefore: "dateIsBefore",
  dateIsAfter: "dateIsAfter",
  textContains: "textContains",
  textDoesNotContain: "textDoesNotContain",
  textStartsWith: "textStartsWith",
  textEndsWith: "textEndsWith",
  textIsExactly: "textIsExactly",
})